import $ from 'jquery';
import ImageTeaser from './image-teaser';

export default class Application {
	constructor() {
		this.imageTeaser = new ImageTeaser();
	}

	init() {
		this.calcSizesHighlight();
		this.showTwoElementsMobile();
		this.showMoreThanTwoElementsMobile();
		this.imageTeaser.init();
	}

	calcSizesHighlight() {
		/* TODO This MUST be done via CSS… */
		$('.overlay-text').each((index, element) => {
			if ($(window).width() < 768) {
				$(element).css('height', '0px');
				$(element).css('display', 'none');
			} else {
				$(element).css('height', 'auto');
				$(element).css('display', 'block');
			}
		});

		const elementHighlightCollection = $('.js-highlight-content');

		/* TODO I`m pretty sure this can also be done easier via CSS… */
		if ($(window).width() > 768) {
			elementHighlightCollection.each((index, elementHighlight) => {
				let highest = 0;
				const elementHighlightObj = $(elementHighlight);
				const padding = 121;

				if (elementHighlightObj.closest('.mobile-link').length > 0) {
					elementHighlightObj.unwrap();
				}

				elementHighlightObj.css('height', '');

				elementHighlightObj
					.children()
					.each((indexChild, elementHighlightChild) => {
						const elementHighlightChildHeight = $(
							elementHighlightChild,
						).outerHeight();
						if (indexChild > 0) {
							if (elementHighlightChildHeight > highest) {
								highest = elementHighlightChildHeight;
							}
						}
					});

				highest += padding;
				elementHighlightObj.css('height', `${highest}px`);
			});
		} else {
			elementHighlightCollection.each((index, elementHighlight) => {
				const elementHighlightObj = $(elementHighlight);
				const titleHeight = elementHighlightObj.find('.title').outerHeight();
				const headlineHeight = elementHighlightObj
					.find('.headline')
					.outerHeight();
				const contentHeight = Math.ceil(
					0 +
						(Number.isNaN(titleHeight) ? -10 : titleHeight) +
						(Number.isNaN(headlineHeight) ? 0 : headlineHeight),
				);
				const padding = $(window).width() < 576 ? 30 : 57;
				elementHighlightObj.css('height', `${contentHeight + padding}px`);

				if (elementHighlightObj.closest('.mobile-link').length === 0) {
					const $link = elementHighlightObj.find('.link a');
					const $btnlink = elementHighlightObj.find('.button a');

					if ($link.length) {
						elementHighlightObj.wrap(
							`<a class="mobile-link" href="${$link.prop('href')}"></div>`,
						);
					} else if ($btnlink.length) {
						elementHighlightObj.wrap(
							`<a class="mobile-link" href="${$btnlink.prop('href')}"></div>`,
						);
					}
				}
			});
		}
	}

	showTwoElementsMobile() {
		const tiles = $('.buhck-tile.list-view');
		if (tiles.length >= 2) {
			tiles.each((index, element) => {
				if (index >= 2) {
					$(element).addClass('show-if-click-more');
				}
				if (index === tiles.length - 1) {
					$(element)
						.parent()
						.append(
							'<div class="show-more-tiles-mobile"><a class="link link-animated-underline primary-arrow">Weitere Kennzahlen anzeigen</a></div>',
						);
				}
			});
		}
	}

	showMoreThanTwoElementsMobile() {
		const moreButton = $('.show-more-tiles-mobile');
		moreButton.each((index, element) => {
			element.addEventListener('click', () => {
				$('.buhck-tile.show-if-click-more').removeClass('show-if-click-more');
				$(element).css('display', 'none');
			});
		});
	}

	// On resize Window
	responsive(window) {
		this.calcSizesHighlight(window);
	}
}

$(document).ready(() => {
	const application = new Application();
	const win = $(window);

	application.init();
	win.resize(() => {
		application.responsive(win);
	});
});
